// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import 'lib-flexible'
import App from './App.vue'
import axios from 'axios'
import qs from 'qs'
import VueAxios from 'vue-axios'
import Common from './assets/js/common'
import VueClipboard from 'vue-clipboard2'
import Vant from 'vant'
import 'vant/lib/index.css'
import './css/content-styles.css'
import globalConfig from './api/global-config'

Vue.use(Vant)
Vue.use(VueClipboard)

Vue.use(Common)
Vue.prototype.axios = axios
Vue.prototype.global = globalConfig
Vue.use(VueAxios, axios, qs)

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  watch: {
    "$route": function(){
      var shareData = {
        title: document.title,
        link: window.location.href,
        desc: "#九洲福#，经络穴位速查，常见病症艾灸、刮痧、拔罐方法，穴位养生介绍",
        imgUrl: "http://know.gmmatou.com/static/img/share.jpg"
      }
      wx.updateAppMessageShareData (shareData)
      wx.updateTimelineShareData(shareData)
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js